module.exports = __webpack_public_path__ + "static/media/wineGlassFull.e6e4f5b5.svg";